import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleAppointment = () => {
    setMenuOpen(false);

    if (window.location.pathname === "/contact") {
      setTimeout(() => {
        document
          .getElementById("contact-form")
          ?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 100);
    } else {
      navigate("/contact#contact-form");
    }
  };

  return (
    <nav className="navbar">
      <div className="nav-wrapper">

        {/* LOGO */}
        <Link
          to="/"
          className="brand"
          onClick={() => setMenuOpen(false)}
        >
          <div className="brand-mark">
            M
          </div>

          <div className="brand-name">
            <h1 id="sl">Makeup by Tanya</h1>
            <span>BEAUTY • COSMETICS</span>
          </div>
        </Link>


        {/* NAVIGATION */}
        <ul className={`nav-links ${menuOpen ? "open" : ""}`}>

          <li>
            <Link
              to="/"
              onClick={() => setMenuOpen(false)}
            >
              Makeup by Tanya
            </Link>
          </li>

          <li>
            <Link
              to="/contact"
              onClick={() => setMenuOpen(false)}
            >
              Contact Us
            </Link>
          </li>


          {/* MOBILE APPOINTMENT */}
          <li className="mobile-appointment">
            <button
              type="button"
              className="mobile-appointment-btn"
              onClick={handleAppointment}
            >
              <span>Book an Appointment</span>
              <span>→</span>
            </button>
          </li>

        </ul>


        {/* DESKTOP APPOINTMENT */}
        <div className="nav-actions">

          <button
            type="button"
            className="shop-btn"
            onClick={handleAppointment}
          >
            <span>Book an Appointment</span>
            <span>→</span>
          </button>

        </div>


        {/* HAMBURGER */}
        <button
          className={`hamburger ${menuOpen ? "active" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle navigation"
          type="button"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

      </div>
    </nav>
  );
}

export default App;